import { render, staticRenderFns } from "./SayfaListesi.vue?vue&type=template&id=12e425ba&scoped=true&"
import script from "./SayfaListesi.vue?vue&type=script&lang=js&"
export * from "./SayfaListesi.vue?vue&type=script&lang=js&"
import style0 from "./SayfaListesi.vue?vue&type=style&index=0&id=12e425ba&lang=scss&scoped=true&"
import style1 from "./SayfaListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e425ba",
  null
  
)

export default component.exports